import {
	ADD_TODO,
	DELETE_TODO,
	EDIT_TODO,
	COMPLETE_TODO,
	COMPLETE_ALL_TODOS,
	CLEAR_COMPLETED,
	SET_FILTERED_TODOS,
	SET_TODOS
} from '../constants/ActionTypes';

const initialState = { allTodos: [], visibleTodos: [] };
let id = 1000;

export default function todos(state = initialState, action) {
	switch (action.type) {
		case ADD_TODO:
			return {
				...state,
				allTodos: [
					...state.allTodos,
					{
						id: id++,
						...action.todo
					}
				]
			};

		case DELETE_TODO:
			return {
				...state,
				allTodos: state.allTodos.filter(todo => todo.id !== action.id)
			};

		case EDIT_TODO:
			return {
				...state,
				allTodos: state.allTodos.map(
					todo =>
						todo.id === action.id ? { ...todo, text: action.text } : todo
				)
			};

		case SET_TODOS:
			return { ...state, allTodos: action.todos };

		case COMPLETE_TODO:
			return {
				...state,
				allTodos: state.allTodos.map(
					todo =>
						todo.id === action.id
							? { ...todo, completed: !todo.completed }
							: todo
				)
			};

		case COMPLETE_ALL_TODOS:
			const areAllMarked = state.every(todo => todo.completed);
			return {
				...state,
				allTodos: state.allTodos.map(todo => ({
					...todo,
					completed: !areAllMarked
				}))
			};

		case CLEAR_COMPLETED:
			return {
				...state,
				allTodos: state.allTodos.filter(todo => todo.completed === false)
			};

		case SET_FILTERED_TODOS:
			return {
				...state,
				visibleTodos: action.todos.map(todo => ({
					text: todo.message,
					completed: todo.status === 'COMPLETED',
					id: id++
				}))
			};
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/todos.js